import React, { useState } from 'react';
import { InstantSearch, Configure } from 'react-instantsearch-dom';
import NumberHits from './NumberHits';
import BoxlessSearch from './BoxlessSearch';

interface Props {
  searchClient: any,
  indexName: string,
  facetFilters: Array<string|Array<string>>,
  numericFilters: Array<string>,
}

const IndexLength: React.FC<Props> = ({
  searchClient,
  indexName,
  facetFilters,
  numericFilters,
}) => {
  const [searchState, onSearchStateChange] = useState({ query: '' });
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      searchState={searchState}
      onSearchStateChange={onSearchStateChange}
    >
      <Configure
        facetFilters={facetFilters}
        numericFilters={numericFilters}
      />
      <BoxlessSearch />
      <NumberHits />
    </InstantSearch>
  );
};

IndexLength.defaultProps = {
  facetFilters: [],
  numericFilters: [],
};

export default IndexLength;
